<cu-building-block-resolver
  *ngIf="field?.visible"
  [page]="page"
  [card]="card"
  [field]="field"
  [pageSubmitted$]="pageSubmitted$"
  [class.bl-validation-error]="field?.visible && !field?.valid && ((!field.focused && field?.dirty) || (pageSubmitted$ | async))"
>
</cu-building-block-resolver>

<span
  *ngIf="field?.description || (field?.visible && !field?.valid && ((!field.focused && field?.dirty) || (pageSubmitted$ | async)))"
  id="{{ field.id }}-desc-container"
  [ngClass]="{ 'bl-font-size--14 bl-font-color--steel bl-display--block bl-margin-top--4': field?.description }"
>
  <!-- field description text if available -->
  {{ field.description }}

  <!-- field validation text -->
  <cu-validation-messages
    *ngIf="field?.visible && !field?.valid && ((!field.focused && field?.dirty) || (pageSubmitted$ | async))"
    [pageIterationId]="field.pageIterationId"
    [fieldId]="field.id"
    [fieldLabel]="field.label"
    [iterationId]="field.iterationId"
    [failedValidations]="field.failedValidations"
    [validationMessages]="field.config.validationMsg"
  >
  </cu-validation-messages>
</span>

<!-- field info tip -->
<ea-info-tip *ngIf="field?.visible && field?.infoTip" [infoTipPrompt]="field.infoTipPrompt" class="bl-margin-top--16">
  <span [innerHTML]="field.infoTip"></span>
</ea-info-tip>

<!-- Note: this is a spacer between dynamic fields (field, validation message and infotip)
it cannot be added to the bottom of any of those elements due to how dynamic the layout can be
(unless we want to create and keep track of conditional logic to set css classes) -->
<div *ngIf="field?.config?.type !== 'field-group'" class="bl-margin-bottom--16"></div>
